
export const edgeSample = {
    iot0001c037a4f4: {
        "timestamp": "2026-09-07T10:25:17.069403Z",
        "device_id": "iot0001c037a4f4",
        "monitoring_capabilities": {
            "system": true,
            "containers": true,
            "logs": true,
            "stream_manager": true,
            "can_interface": true
        },
        "report_interval_seconds": 300,
        "system": {
            "timestamp": "2026-09-07T20:53:23.170555Z",
            "enabled": true,
            "cpu": {
                "percent": 33.9,
                "per_cpu": [
                    26.1,
                    28.4,
                    40.2,
                    39.9
                ],
                "count": 4,
                "count_logical": 4,
                "times": {
                    "user": 11490175.36,
                    "system": 743755.43,
                    "idle": 30554982.18
                },
                "stats": {
                    "ctx_switches": 28625833424,
                    "interrupts": 9473159395,
                    "soft_interrupts": 8168991140,
                    "syscalls": 0
                },
                "load_avg": {
                    "1min": 1.13,
                    "5min": 1.5,
                    "15min": 1.51
                }
            },
            "memory": {
                "total": 3778351104,
                "available": 1378271232,
                "used": 2400079872,
                "free": 139862016,
                "percent": 63.5,
                "buffers": 193384448,
                "cached": 1299705856,
                "shared": 66293760,
                "swap": {
                    "total": 0,
                    "used": 0,
                    "free": 0,
                    "percent": 0,
                    "sin": 0,
                    "sout": 0
                }
            },
            "disk": {
                "partitions": {
                    "/": {
                        "device": "/dev/mmcblk2p2",
                        "fstype": "ext4",
                        "total": 30990528512,
                        "used": 15317606400,
                        "free": 14373695488,
                        "percent": 49.43
                    },
                    "/mnt/iot": {
                        "device": "/dev/loop0",
                        "fstype": "ext4",
                        "total": 11516715008,
                        "used": 75173888,
                        "free": 10834206720,
                        "percent": 0.65
                    }
                },
                "io_stats": {
                    "read_count": 323554,
                    "write_count": 64486240,
                    "read_bytes": 10722731008,
                    "write_bytes": 772967849984,
                    "read_time": 397095,
                    "write_time": 345689423
                }
            },
            "network": {
                "interfaces": {
                    "lo": {
                        "bytes_sent": 6767374096,
                        "bytes_recv": 6767374096,
                        "packets_sent": 45698395,
                        "packets_recv": 45698395,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "end0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "end1": {
                        "bytes_sent": 1477194380,
                        "bytes_recv": 4779973885,
                        "packets_sent": 15464363,
                        "packets_recv": 31511583,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 3290768,
                        "dropout": 0
                    },
                    "canC": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "canE": {
                        "bytes_sent": 18045343704,
                        "bytes_recv": 36090687408,
                        "packets_sent": 2255667963,
                        "packets_recv": 4511335926,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "wwx266a89f9db09": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "wlp1s0": {
                        "bytes_sent": 72605450674,
                        "bytes_recv": 7810018503,
                        "packets_sent": 26402415,
                        "packets_recv": 51183543,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "zteb4lsfsu": {
                        "bytes_sent": 214357,
                        "bytes_recv": 71426028,
                        "packets_sent": 3038,
                        "packets_recv": 498757,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "ztcfw37n7l": {
                        "bytes_sent": 212033,
                        "bytes_recv": 65924731,
                        "packets_sent": 2998,
                        "packets_recv": 419315,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "ztre46jorm": {
                        "bytes_sent": 212060,
                        "bytes_recv": 0,
                        "packets_sent": 2993,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "docker0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    }
                },
                "connections_count": 45
            },
            "system_info": {
                "boot_time": "2026-09-07T09:52:43",
                "uptime_seconds": 10869434,
                "users": 0,
                "processes": 177
            },
            "cpu_percent": 33.9,
            "memory_percent": 63.5,
            "disk_usage": {
                "/": 49.43,
                "/mnt/iot": 0.65
            }
        },
        "containers": {
            "timestamp": "2026-09-07T21:56:34.787352Z",
            "enabled": true,
            "containers": [
                {
                    "name": "iot-candump-uploader",
                    "id": "9c20c5c6844d3e23cd36b018ad907d3e80f99afceeeb1d12c4c8e838042cd70d",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.850374044Z",
                    "started": "2026-09-07T10:25:27.960361929Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.06,
                        "memory": {
                            "usage_bytes": 16527360,
                            "limit_bytes": 3778351104,
                            "usage_mb": 15.76,
                            "limit_mb": 3603.32,
                            "percent": 0.44,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/candump-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-blackbox",
                    "id": "561f19542eebc552783a5bae1966b6c8d1d4f6778ebf7307fcca1f4729dafd21",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.821984085Z",
                    "started": "2026-09-07T10:25:27.963833936Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 12.66,
                        "memory": {
                            "usage_bytes": 249679872,
                            "limit_bytes": 3778351104,
                            "usage_mb": 238.11,
                            "limit_mb": 3603.32,
                            "percent": 6.61,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/blackbox",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        }
                    ]
                },
                {
                    "name": "iot-candump",
                    "id": "fe50456b1597cfa26f600c1023764c3f846207050872ab5abbd3895e84dcf199",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-candump:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.777370007Z",
                    "started": "2026-09-07T10:25:27.870788008Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "health": {
                        "status": "unhealthy",
                        "failing_streak": 312247,
                        "log": {
                            "Start": "2026-09-07T05:09:31.884166963Z",
                            "End": "2026-09-07T05:09:31.98239235Z",
                            "ExitCode": 1,
                            "Output": "/bin/sh: 1: pgrep: not found\n"
                        }
                    },
                    "resources": {
                        "cpu_percent": 4.27,
                        "memory": {
                            "usage_bytes": 61370368,
                            "limit_bytes": 3778351104,
                            "usage_mb": 58.53,
                            "limit_mb": 3603.32,
                            "percent": 1.62,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/candumps",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/var/lib/iot",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/device-config.json",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-batch-uploader",
                    "id": "c9036d26ebcd595e755d8e29c1224fbf91eb913f958a770370df031b8d782edb",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.711554369Z",
                    "started": "2026-09-07T10:25:27.950894817Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.08,
                        "memory": {
                            "usage_bytes": 22945792,
                            "limit_bytes": 3778351104,
                            "usage_mb": 21.88,
                            "limit_mb": 3603.32,
                            "percent": 0.61,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/batch-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-fsbms",
                    "id": "097fedb1323ccc080efef9dabf91d85593d849d255a2c03832c6903cf6261fd1",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.700335066Z",
                    "started": "2026-09-07T10:25:27.974707977Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 11.41,
                        "memory": {
                            "usage_bytes": 270811136,
                            "limit_bytes": 3778351104,
                            "usage_mb": 258.27,
                            "limit_mb": 3603.32,
                            "percent": 7.17,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-packs-simulator",
                    "id": "2b1128cae770209fbbc6582e56de591f1db341fbfab3128c0100932989189ab7",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-packs-simulator:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:24:31.297962702Z",
                    "started": "2026-09-07T10:24:31.474311558Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 1.4,
                        "memory": {
                            "usage_bytes": 505794560,
                            "limit_bytes": 3778351104,
                            "usage_mb": 482.36,
                            "limit_mb": 3603.32,
                            "percent": 13.39,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/container/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        }
                    ]
                }
            ],
            "summary": {
                "total_containers": 6,
                "running": 6,
                "stopped": 0,
                "paused": 0,
                "restarting": 0,
                "unhealthy": 1,
                "total_cpu_percent": 29.88,
                "total_memory_mb": 1074.91,
                "containers_with_errors": 0
            }
        },
        "logs": {
            "timestamp": "2026-09-07T08:49:41.356699Z",
            "enabled": true,
            "files_configured": 7,
            "files_accessible": 7,
            "errors": [],
            "warnings": [
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:02.542Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:06:49,442 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T03:05:24.101Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:02.933Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:06:49,932 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T11:36:12.738Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:23.160Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:10,059 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T20:19:53.669Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:23.178Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:10,077 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T05:29:24.283Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:32.573Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:19,472 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T04:13:48.352Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:58.776Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:45,675 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T22:20:13.687Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:02.584Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:49,483 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T12:24:38.490Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:02.047Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:49,946 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T20:29:09.277Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:23.249Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:10,147 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T21:30:35.173Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:23.269Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:10,168 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T11:14:08.534Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:32.595Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:19,494 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T20:44:35.230Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:58.868Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:45,767 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T21:20:53.805Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:02.606Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:49,504 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T09:05:54.244Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:03.133Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:50,032 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T13:57:37.418Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:23.260Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:10,158 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3603, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T08:44:59.716Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:23.278Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:10,177 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3603, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T03:09:40.167Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:32.617Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:19,515 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T20:04:38.665Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:58.877Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:45,775 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T22:27:21.291Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:20:02.641Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:49,539 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T03:24:17.475Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:20:03.234Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:50,132 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T12:05:35.307Z",
                    "level": "warning"
                }
            ],
            "summary": {
                "total_errors": 0,
                "total_warnings": 20,
                "errors_by_source": {},
                "warnings_by_source": {
                    "device_controller": 45,
                    "batch_uploader": 58,
                    "candump_uploader": 11,
                    "fsbms": 30,
                    "blackbox": 30
                },
                "files_with_errors": 0,
                "total_lines_scanned": 174
            }
        },
        "stream_manager": {
            "enabled": true,
            "connected": true,
            "timestamp": "2026-09-07T23:16:32.798975Z",
            "streams": [
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 10436
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 39989
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-staging-us-east-1-iot-status",
                    "message_count": 0
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 10436
                },
                {
                    "name": "candump-uploader-bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 42
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-staging-us-east-1-iot-status",
                    "message_count": 0
                },
                {
                    "name": "batch-uploader-bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 1196
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 77881
                },
                {
                    "name": "bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 0
                },
                {
                    "name": "bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 0
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-staging-us-east-1-iot-data",
                    "message_count": 0
                },
                {
                    "name": "batch-uploader-bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 1196
                },
                {
                    "name": "candump-uploader-bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 42
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-staging-us-east-1-iot-data",
                    "message_count": 0
                }
            ],
            "total_streams": 14,
            "total_messages": 141218
        },
        "can_interface": {
            "interface": "canE",
            "configured": true,
            "timestamp": "2026-09-07T11:56:53.845964",
            "operational_state": "up",
            "interface_details": "5: canE: <NOARP,UP,LOWER_UP,ECHO> mtu 16 qdisc pfifo_fast state UP mode DEFAULT group default qlen 10\n    link/can  promiscuity 0 minmtu 0 maxmtu 0 \n    can <LOOPBACK> state ERROR-ACTIVE (berr-counter tx 0 rx 0) restart-ms 0 \n\t  bitrate 250000 sample-point 0.875\n\t  tq 50 prop-seg 37 phase-seg1 32 phase-seg2 10 sjw 1 brp 2\n\t  flexcan: tseg1 2..96 tseg2 2..32 sjw 1..16 brp 1..1024 brp_inc 1\n\t  flexcan: dtseg1 2..39 dtseg2 2..8 dsjw 1..4 dbrp 1..1024 dbrp_inc 1\n\t  clock 40000000 numtxqueues 1 numrxqueues 1 gso_max_size 65536 gso_max_segs 65535 parentbus platform parentdev 308d0000.can",
            "state": "UP",
            "statistics": {
                "rx_packets": "36090731024",
                "rx_bytes": "4511341378",
                "rx_errors": "0",
                "rx_dropped": "0",
                "tx_packets": "18045365512",
                "tx_bytes": "2255670689",
                "tx_errors": "0",
                "tx_dropped": "0"
            },
            "manager_stats": {
                "setup_count": 1,
                "recovery_count": 1,
                "failed_recovery_count": 0,
                "recovery_attempts": 0,
                "last_error": null
            },
            "uptime_seconds": 9398535
        },
        "alerts": [
            {
                "level": "warning",
                "message": "Stream Manager message backlog warning: 141218 messages",
                "timestamp": "2026-09-07T04:15:47.588637Z"
            }
        ],
        "topic": "iot/devices/iot0001c037a4fc/health"
    },
    iot0001c039f88e: {
        "timestamp": "2026-09-07T15:45:56.958972Z",
        "device_id": "iot0001c039f88e",
        "monitoring_capabilities": {
            "system": true,
            "containers": true,
            "logs": true,
            "stream_manager": true,
            "can_interface": true
        },
        "report_interval_seconds": 300,
        "system": {
            "timestamp": "2026-09-07T17:32:45.681453Z",
            "enabled": true,
            "cpu": {
                "percent": 31.2,
                "per_cpu": [
                    23.8,
                    30.6,
                    37.4,
                    43.1
                ],
                "count": 4,
                "count_logical": 4,
                "times": {
                    "user": 10623847.21,
                    "system": 797293.61,
                    "idle": 28613705.42
                },
                "stats": {
                    "ctx_switches": 30834127391,
                    "interrupts": 8712903894,
                    "soft_interrupts": 8749823181,
                    "syscalls": 0
                },
                "load_avg": {
                    "1min": 1.24,
                    "5min": 1.39,
                    "15min": 1.62
                }
            },
            "memory": {
                "total": 3778351104,
                "available": 1489423217,
                "used": 2183272680,
                "free": 149352237,
                "percent": 57.8,
                "buffers": 208131362,
                "cached": 1183533129,
                "shared": 72256099,
                "swap": {
                    "total": 0,
                    "used": 0,
                    "free": 0,
                    "percent": 0,
                    "sin": 0,
                    "sout": 0
                }
            },
            "disk": {
                "partitions": {
                    "/": {
                        "device": "/dev/mmcblk2p2",
                        "fstype": "ext4",
                        "total": 30990528512,
                        "used": 16091116044,
                        "free": 13543824985,
                        "percent": 52.18
                    },
                    "/mnt/iot": {
                        "device": "/dev/loop0",
                        "fstype": "ext4",
                        "total": 11516715008,
                        "used": 82691277,
                        "free": 10027941322,
                        "percent": 0.72
                    }
                },
                "io_stats": {
                    "read_count": 301283,
                    "write_count": 70147321,
                    "read_bytes": 9762103918,
                    "write_bytes": 842334657322,
                    "read_time": 428463,
                    "write_time": 320914861
                }
            },
            "network": {
                "interfaces": {
                    "lo": {
                        "bytes_sent": 7283977524,
                        "bytes_recv": 7283977524,
                        "packets_sent": 42192487,
                        "packets_recv": 42192487,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "end0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "end1": {
                        "bytes_sent": 1624913818,
                        "bytes_recv": 4444475013,
                        "packets_sent": 14227693,
                        "packets_recv": 34345325,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 2978492,
                        "dropout": 0
                    },
                    "canC": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "canE": {
                        "bytes_sent": 16562265607,
                        "bytes_recv": 39699756149,
                        "packets_sent": 2098521226,
                        "packets_recv": 4872242800,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "wlp1s0": {
                        "bytes_sent": 67443569127,
                        "bytes_recv": 8434819983,
                        "packets_sent": 28358396,
                        "packets_recv": 46065189,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "docker0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    }
                },
                "connections_count": 49
            },
            "system_info": {
                "boot_time": "2026-09-07T09:52:43",
                "uptime_seconds": 11713147,
                "users": 0,
                "processes": 162
            },
            "cpu_percent": 31.2,
            "memory_percent": 57.8,
            "disk_usage": {
                "/": 52.18,
                "/mnt/iot": 0.72
            }
        },
        "containers": {
            "timestamp": "2026-09-07T01:21:05.229258Z",
            "enabled": true,
            "containers": [
                {
                    "name": "iot-candump-uploader",
                    "id": "9c20c5c6844d3e23cd36b018ad907d3e80f99afceeeb1d12c4c8e838042cd70d",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.850374044Z",
                    "started": "2026-09-07T10:25:27.960361929Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.07,
                        "memory": {
                            "usage_bytes": 18029122,
                            "limit_bytes": 3778351104,
                            "usage_mb": 17.19,
                            "limit_mb": 3603.32,
                            "percent": 0.48,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/candump-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-blackbox",
                    "id": "561f19542eebc552783a5bae1966b6c8d1d4f6778ebf7307fcca1f4729dafd21",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.821984085Z",
                    "started": "2026-09-07T10:25:27.963833936Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 13.78,
                        "memory": {
                            "usage_bytes": 271850461,
                            "limit_bytes": 3778351104,
                            "usage_mb": 259.54,
                            "limit_mb": 3603.32,
                            "percent": 7.20,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/blackbox",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        }
                    ]
                },
                {
                    "name": "iot-candump",
                    "id": "fe50456b1597cfa26f600c1023764c3f846207050872ab5abbd3895e84dcf199",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-candump:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.777370007Z",
                    "started": "2026-09-07T10:25:27.870788008Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "health": {
                        "status": "unhealthy",
                        "failing_streak": 340749,
                        "log": {
                            "Start": "2026-09-07T05:09:31.884166963Z",
                            "End": "2026-09-07T05:09:31.98239235Z",
                            "ExitCode": 1,
                            "Output": "/bin/sh: 1: pgrep: not found\n"
                        }
                    },
                    "resources": {
                        "cpu_percent": 3.87,
                        "memory": {
                            "usage_bytes": 56460938,
                            "limit_bytes": 3778351104,
                            "usage_mb": 53.83,
                            "limit_mb": 3603.32,
                            "percent": 1.49,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/candumps",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/var/lib/iot",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/device-config.json",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-batch-uploader",
                    "id": "c9036d26ebcd595e755d8e29c1224fbf91eb913f958a770370df031b8d782edb",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.711554369Z",
                    "started": "2026-09-07T10:25:27.950894817Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.09,
                        "memory": {
                            "usage_bytes": 24992763,
                            "limit_bytes": 3778351104,
                            "usage_mb": 23.85,
                            "limit_mb": 3603.32,
                            "percent": 0.67,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/batch-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-fsbms",
                    "id": "097fedb1323ccc080efef9dabf91d85593d849d255a2c03832c6903cf6261fd1",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.700335066Z",
                    "started": "2026-09-07T10:25:27.974707977Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 10.27,
                        "memory": {
                            "usage_bytes": 247140135,
                            "limit_bytes": 3778351104,
                            "usage_mb": 235.73,
                            "limit_mb": 3603.32,
                            "percent": 6.46,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-packs-simulator",
                    "id": "2b1128cae770209fbbc6582e56de591f1db341fbfab3128c0100932989189ab7",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-packs-simulator:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:24:31.297962702Z",
                    "started": "2026-09-07T10:24:31.474311558Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 1.54,
                        "memory": {
                            "usage_bytes": 554198522,
                            "limit_bytes": 3778351104,
                            "usage_mb": 528.64,
                            "limit_mb": 3603.32,
                            "percent": 14.68,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/container/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        }
                    ]
                }
            ],
            "summary": {
                "total_containers": 6,
                "running": 6,
                "stopped": 0,
                "paused": 0,
                "restarting": 0,
                "unhealthy": 1,
                "total_cpu_percent": 32.27,
                "total_memory_mb": 973.86,
                "containers_with_errors": 0
            }
        },
        "logs": {
            "timestamp": "2026-09-07T22:54:26.231148Z",
            "enabled": true,
            "files_configured": 7,
            "files_accessible": 7,
            "errors": [],
            "warnings": [
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:02.542Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:06:49,442 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T01:34:52.033Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:02.933Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:06:49,932 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T16:36:35.902Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:23.160Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:10,059 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T01:03:46.120Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:23.178Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:10,077 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T15:25:48.049Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:32.573Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:19,472 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T16:58:12.160Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:58.776Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:07:45,675 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3600, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T14:57:17.848Z",
                    "level": "warning"
                }
            ],
            "summary": {
                "total_errors": 0,
                "total_warnings": 20,
                "errors_by_source": {},
                "warnings_by_source": {
                    "device_controller": 45,
                    "batch_uploader": 58,
                    "candump_uploader": 11,
                    "fsbms": 30,
                    "blackbox": 30
                },
                "files_with_errors": 0,
                "total_lines_scanned": 174
            }
        },
        "stream_manager": {
            "enabled": true,
            "connected": true,
            "timestamp": "2026-09-07T01:08:51.167414Z",
            "streams": [
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 11382
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 36851
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-staging-us-east-1-iot-status",
                    "message_count": 0
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 10436
                },
                {
                    "name": "candump-uploader-bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 46
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-staging-us-east-1-iot-status",
                    "message_count": 0
                },
                {
                    "name": "batch-uploader-bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 1076
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 84359
                },
                {
                    "name": "bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 0
                },
                {
                    "name": "bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 0
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-staging-us-east-1-iot-data",
                    "message_count": 0
                },
                {
                    "name": "batch-uploader-bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 1196
                },
                {
                    "name": "candump-uploader-bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 42
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-staging-us-east-1-iot-data",
                    "message_count": 0
                }
            ],
            "total_streams": 14,
            "total_messages": 152715
        },
        "can_interface": {
            "interface": "canE",
            "configured": true,
            "timestamp": "2026-09-07T09:35:03.252572",
            "operational_state": "up",
            "interface_details": "5: canE: <NOARP,UP,LOWER_UP,ECHO> mtu 16 qdisc pfifo_fast state UP mode DEFAULT group default qlen 10\n    link/can  promiscuity 0 minmtu 0 maxmtu 0 \n    can <LOOPBACK> state ERROR-ACTIVE (berr-counter tx 0 rx 0) restart-ms 0 \n\t  bitrate 250000 sample-point 0.875\n\t  tq 50 prop-seg 37 phase-seg1 32 phase-seg2 10 sjw 1 brp 2\n\t  flexcan: tseg1 2..96 tseg2 2..32 sjw 1..16 brp 1..1024 brp_inc 1\n\t  flexcan: dtseg1 2..39 dtseg2 2..8 dsjw 1..4 dbrp 1..1024 dbrp_inc 1\n\t  clock 40000000 numtxqueues 1 numrxqueues 1 gso_max_size 65536 gso_max_segs 65535 parentbus platform parentdev 308d0000.can",
            "state": "UP",
            "statistics": {
                "rx_packets": "33203472422",
                "rx_bytes": "4869608488",
                "rx_errors": "0",
                "rx_dropped": "0",
                "tx_packets": "19669248408",
                "tx_bytes": "2072316434",
                "tx_errors": "0",
                "tx_dropped": "0"
            },
            "manager_stats": {
                "setup_count": 1,
                "recovery_count": 1,
                "failed_recovery_count": 0,
                "recovery_attempts": 0,
                "last_error": null
            },
            "uptime_seconds": 10151538
        },
        "alerts": [
            {
                "level": "warning",
                "message": "Stream Manager message backlog warning: 152715 messages",
                "timestamp": "2026-09-07T02:22:42.238968Z"
            }
        ],
        "topic": "iot/devices/iot0001c037a4fc/health"
    },
    iot0001c037a4fc: {
        "timestamp": "2026-09-07T08:10:36.918938Z",
        "device_id": "iot0001c037a4fc",
        "monitoring_capabilities": {
            "system": true,
            "containers": true,
            "logs": true,
            "stream_manager": true,
            "can_interface": true
        },
        "report_interval_seconds": 210,
        "system": {
            "timestamp": "2026-09-07T08:44:38.027824Z",
            "enabled": true,
            "cpu": {
                "percent": 23.7,
                "per_cpu": [
                    18.3,
                    19.9,
                    28.1,
                    27.9
                ],
                "count": 3,
                "count_logical": 3,
                "times": {
                    "user": 8043122.75,
                    "system": 520628.80,
                    "idle": 21388487.53
                },
                "stats": {
                    "ctx_switches": 20038083397,
                    "interrupts": 6631211576,
                    "soft_interrupts": 5718293798,
                    "syscalls": 0
                },
                "load_avg": {
                    "1min": 0.79,
                    "5min": 1.0,
                    "15min": 1.06
                }
            },
            "memory": {
                "total": 2644845773,
                "available": 964789862,
                "used": 1680055910,
                "free": 97903411,
                "percent": 44.4,
                "buffers": 135369114,
                "cached": 909794099,
                "shared": 46405632,
                "swap": {
                    "total": 0,
                    "used": 0,
                    "free": 0,
                    "percent": 0,
                    "sin": 0,
                    "sout": 0
                }
            },
            "disk": {
                "partitions": {
                    "/": {
                        "device": "/dev/mmcblk2p2",
                        "fstype": "ext4",
                        "total": 21693369958,
                        "used": 10722324480,
                        "free": 10061586842,
                        "percent": 34.60
                    },
                    "/mnt/iot": {
                        "device": "/dev/loop0",
                        "fstype": "ext4",
                        "total": 8061700506,
                        "used": 52621722,
                        "free": 7583944704,
                        "percent": 0.45
                    }
                },
                "io_stats": {
                    "read_count": 226488,
                    "write_count": 45140368,
                    "read_bytes": 7505911706,
                    "write_bytes": 541077494989,
                    "read_time": 277966,
                    "write_time": 241982596
                }
            },
            "network": {
                "interfaces": {
                    "lo": {
                        "bytes_sent": 4737161867,
                        "bytes_recv": 4737161867,
                        "packets_sent": 31988876,
                        "packets_recv": 31988876,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "end0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "end1": {
                        "bytes_sent": 1034036066,
                        "bytes_recv": 3345981720,
                        "packets_sent": 10825054,
                        "packets_recv": 22058108,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 2303538,
                        "dropout": 0
                    },
                    "canC": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "canE": {
                        "bytes_sent": 12631740593,
                        "bytes_recv": 25263481186,
                        "packets_sent": 1578967574,
                        "packets_recv": 3157935148,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "docker0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    }
                },
                "connections_count": 31
            },
            "system_info": {
                "boot_time": "2026-09-07T09:52:43",
                "uptime_seconds": 7608604,
                "users": 0,
                "processes": 124
            },
            "cpu_percent": 23.7,
            "memory_percent": 44.4,
            "disk_usage": {
                "/": 34.60,
                "/mnt/iot": 0.45
            }
        },
        "containers": {
            "timestamp": "2026-09-07T04:30:27.165840Z",
            "enabled": true,
            "containers": [
                {
                    "name": "iot-candump-uploader",
                    "id": "9c20c5c6844d3e23cd36b018ad907d3e80f99afceeeb1d12c4c8e838042cd70d",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.850374044Z",
                    "started": "2026-09-07T10:25:27.960361929Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.04,
                        "memory": {
                            "usage_bytes": 11569152,
                            "limit_bytes": 2644845773,
                            "usage_mb": 11.03,
                            "limit_mb": 2522.32,
                            "percent": 0.31,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/candump-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-blackbox",
                    "id": "561f19542eebc552783a5bae1966b6c8d1d4f6778ebf7307fcca1f4729dafd21",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.821984085Z",
                    "started": "2026-09-07T10:25:27.963833936Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 8.86,
                        "memory": {
                            "usage_bytes": 174775910,
                            "limit_bytes": 2644845773,
                            "usage_mb": 166.68,
                            "limit_mb": 2522.32,
                            "percent": 4.63,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/blackbox",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        }
                    ]
                },
                {
                    "name": "iot-candump",
                    "id": "fe50456b1597cfa26f600c1023764c3f846207050872ab5abbd3895e84dcf199",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-candump:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.777370007Z",
                    "started": "2026-09-07T10:25:27.870788008Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "health": {
                        "status": "unhealthy",
                        "failing_streak": 218573,
                        "log": {
                            "Start": "2026-09-07T05:09:31.884166963Z",
                            "End": "2026-09-07T05:09:31.98239235Z",
                            "ExitCode": 1,
                            "Output": "/bin/sh: 1: pgrep: not found\n"
                        }
                    },
                    "resources": {
                        "cpu_percent": 2.99,
                        "memory": {
                            "usage_bytes": 42959258,
                            "limit_bytes": 2644845773,
                            "usage_mb": 40.97,
                            "limit_mb": 2522.32,
                            "percent": 1.13,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/candumps",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/var/lib/iot",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/device-config.json",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-batch-uploader",
                    "id": "c9036d26ebcd595e755d8e29c1224fbf91eb913f958a770370df031b8d782edb",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.711554369Z",
                    "started": "2026-09-07T10:25:27.950894817Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.06,
                        "memory": {
                            "usage_bytes": 16062054,
                            "limit_bytes": 2644845773,
                            "usage_mb": 15.32,
                            "limit_mb": 2522.32,
                            "percent": 0.43,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/batch-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-fsbms",
                    "id": "097fedb1323ccc080efef9dabf91d85593d849d255a2c03832c6903cf6261fd1",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.700335066Z",
                    "started": "2026-09-07T10:25:27.974707977Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 7.99,
                        "memory": {
                            "usage_bytes": 189567795,
                            "limit_bytes": 2644845773,
                            "usage_mb": 180.79,
                            "limit_mb": 2522.32,
                            "percent": 5.02,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-packs-simulator",
                    "id": "2b1128cae770209fbbc6582e56de591f1db341fbfab3128c0100932989189ab7",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-packs-simulator:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:24:31.297962702Z",
                    "started": "2026-09-07T10:24:31.474311558Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 1.0,
                        "memory": {
                            "usage_bytes": 354056192,
                            "limit_bytes": 2644845773,
                            "usage_mb": 337.65,
                            "limit_mb": 2522.32,
                            "percent": 9.37,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/container/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        }
                    ]
                }
            ],
            "summary": {
                "total_containers": 4,
                "running": 4,
                "stopped": 0,
                "paused": 0,
                "restarting": 0,
                "unhealthy": 1,
                "total_cpu_percent": 20.92,
                "total_memory_mb": 752.44,
                "containers_with_errors": 0
            }
        },
        "logs": {
            "timestamp": "2026-09-07T21:51:56.903565Z",
            "enabled": true,
            "files_configured": 5,
            "files_accessible": 5,
            "errors": [],
            "warnings": [
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:02.606Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:49,504 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-08T00:18:43.776Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:03.133Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:50,032 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T13:06:22.633Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:23.260Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:10,158 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3603, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T11:43:01.117Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:23.278Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:10,177 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3603, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T18:10:00.628Z",
                    "level": "warning"
                }
            ],
            "summary": {
                "total_errors": 0,
                "total_warnings": 14,
                "errors_by_source": {},
                "warnings_by_source": {
                    "device_controller": 31,
                    "batch_uploader": 41,
                    "candump_uploader": 8,
                    "fsbms": 21,
                    "blackbox": 21
                },
                "files_with_errors": 0,
                "total_lines_scanned": 122
            }
        },
        "stream_manager": {
            "enabled": true,
            "connected": true,
            "timestamp": "2026-09-07T18:17:37.442417Z",
            "streams": [
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 7305
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 27992
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 7305
                }
            ],
            "total_streams": 10,
            "total_messages": 98853
        },
        "can_interface": {
            "interface": "canE",
            "configured": true,
            "timestamp": "2026-09-07T12:34:13.702729",
            "operational_state": "up",
            "interface_details": "5: canE: <NOARP,UP,LOWER_UP,ECHO> mtu 16 qdisc pfifo_fast state UP mode DEFAULT group default qlen 10\n    link/can  promiscuity 0 minmtu 0 maxmtu 0 \n    can <LOOPBACK> state ERROR-ACTIVE (berr-counter tx 0 rx 0) restart-ms 0 \n\t  bitrate 250000 sample-point 0.875\n\t  tq 50 prop-seg 37 phase-seg1 32 phase-seg2 10 sjw 1 brp 2\n\t  flexcan: tseg1 2..96 tseg2 2..32 sjw 1..16 brp 1..1024 brp_inc 1\n\t  flexcan: dtseg1 2..39 dtseg2 2..8 dsjw 1..4 dbrp 1..1024 dbrp_inc 1\n\t  clock 40000000 numtxqueues 1 numrxqueues 1 gso_max_size 65536 gso_max_segs 65535 parentbus platform parentdev 308d0000.can",
            "state": "UP",
            "statistics": {
                "rx_packets": "36090731024",
                "rx_bytes": "4511341378",
                "rx_errors": "0",
                "rx_dropped": "0",
                "tx_packets": "18045365512",
                "tx_bytes": "2255670689",
                "tx_errors": "0",
                "tx_dropped": "0"
            },
            "manager_stats": {
                "setup_count": 1,
                "recovery_count": 1,
                "failed_recovery_count": 0,
                "recovery_attempts": 0,
                "last_error": null
            },
            "uptime_seconds": 6578974
        },
        "alerts": [],
        "topic": "iot/devices/iot0001c037a4fc/health"
    },
    iot0001c039f687: {
        "timestamp": "2026-09-07T08:51:02.765179Z",
        "device_id": "iot0001c039f687",
        "monitoring_capabilities": {
            "system": true,
            "containers": true,
            "logs": true,
            "stream_manager": true,
            "can_interface": true
        },
        "report_interval_seconds": 345,
        "system": {
            "timestamp": "2026-09-07T17:49:08.134628Z",
            "enabled": true,
            "cpu": {
                "percent": 39.0,
                "per_cpu": [
                    30.0,
                    32.7,
                    46.2,
                    45.9
                ],
                "count": 5,
                "count_logical": 5,
                "times": {
                    "user": 13213701.66,
                    "system": 855318.74,
                    "idle": 35138229.51
                },
                "stats": {
                    "ctx_switches": 32919708438,
                    "interrupts": 10894133304,
                    "soft_interrupts": 9394339811,
                    "syscalls": 0
                },
                "load_avg": {
                    "1min": 1.30,
                    "5min": 1.7,
                    "15min": 1.74
                }
            },
            "memory": {
                "total": 4345103770,
                "available": 1585011917,
                "used": 2760091853,
                "free": 160841318,
                "percent": 73.0,
                "buffers": 222392115,
                "cached": 1494661734,
                "shared": 76237824,
                "swap": {
                    "total": 0,
                    "used": 0,
                    "free": 0,
                    "percent": 0,
                    "sin": 0,
                    "sout": 0
                }
            },
            "disk": {
                "partitions": {
                    "/": {
                        "device": "/dev/mmcblk2p2",
                        "fstype": "ext4",
                        "total": 35639107789,
                        "used": 17615247360,
                        "free": 16529749811,
                        "percent": 56.84
                    },
                    "/mnt/iot": {
                        "device": "/dev/loop0",
                        "fstype": "ext4",
                        "total": 13244222259,
                        "used": 86449971,
                        "free": 12459337728,
                        "percent": 0.75
                    }
                },
                "io_stats": {
                    "read_count": 372087,
                    "write_count": 74159176,
                    "read_bytes": 12331140659,
                    "write_bytes": 888913027482,
                    "read_time": 456659,
                    "write_time": 397542836
                }
            },
            "network": {
                "interfaces": {
                    "lo": {
                        "bytes_sent": 7782480210,
                        "bytes_recv": 7782480210,
                        "packets_sent": 52553154,
                        "packets_recv": 52553154,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "canC": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "canE": {
                        "bytes_sent": 20752145260,
                        "bytes_recv": 41504290519,
                        "packets_sent": 2594018157,
                        "packets_recv": 5188036315,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    },
                    "docker0": {
                        "bytes_sent": 0,
                        "bytes_recv": 0,
                        "packets_sent": 0,
                        "packets_recv": 0,
                        "errin": 0,
                        "errout": 0,
                        "dropin": 0,
                        "dropout": 0
                    }
                },
                "connections_count": 52
            },
            "system_info": {
                "boot_time": "2026-09-07T09:52:43",
                "uptime_seconds": 12499849,
                "users": 0,
                "processes": 204
            },
            "cpu_percent": 39.0,
            "memory_percent": 73.0,
            "disk_usage": {
                "/": 56.84,
                "/mnt/iot": 0.75
            }
        },
        "containers": {
            "timestamp": "2026-09-07T05:32:58.111579Z",
            "enabled": true,
            "containers": [
                {
                    "name": "iot-candump-uploader",
                    "id": "9c20c5c6844d3e23cd36b018ad907d3e80f99afceeeb1d12c4c8e838042cd70d",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.850374044Z",
                    "started": "2026-09-07T10:25:27.960361929Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.07,
                        "memory": {
                            "usage_bytes": 19006464,
                            "limit_bytes": 4345103770,
                            "usage_mb": 18.12,
                            "limit_mb": 4143.82,
                            "percent": 0.51,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/candump-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-blackbox",
                    "id": "561f19542eebc552783a5bae1966b6c8d1d4f6778ebf7307fcca1f4729dafd21",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.821984085Z",
                    "started": "2026-09-07T10:25:27.963833936Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 14.56,
                        "memory": {
                            "usage_bytes": 287131853,
                            "limit_bytes": 4345103770,
                            "usage_mb": 273.83,
                            "limit_mb": 4143.82,
                            "percent": 7.60,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/blackbox",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        }
                    ]
                },
                {
                    "name": "iot-candump",
                    "id": "fe50456b1597cfa26f600c1023764c3f846207050872ab5abbd3895e84dcf199",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-candump:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.777370007Z",
                    "started": "2026-09-07T10:25:27.870788008Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "health": {
                        "status": "unhealthy",
                        "failing_streak": 359084,
                        "log": {
                            "Start": "2026-09-07T05:09:31.884166963Z",
                            "End": "2026-09-07T05:09:31.98239235Z",
                            "ExitCode": 1,
                            "Output": "/bin/sh: 1: pgrep: not found\n"
                        }
                    },
                    "resources": {
                        "cpu_percent": 4.91,
                        "memory": {
                            "usage_bytes": 70575923,
                            "limit_bytes": 4345103770,
                            "usage_mb": 67.31,
                            "limit_mb": 4143.82,
                            "percent": 1.86,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/mnt/iot/candumps",
                            "destination": "/docker/mapped/candumps",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/var/lib/iot",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/device-config.json",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-batch-uploader",
                    "id": "c9036d26ebcd595e755d8e29c1224fbf91eb913f958a770370df031b8d782edb",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-batch-uploader:1.0.19",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.711554369Z",
                    "started": "2026-09-07T10:25:27.950894817Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 0.09,
                        "memory": {
                            "usage_bytes": 26387661,
                            "limit_bytes": 4345103770,
                            "usage_mb": 25.16,
                            "limit_mb": 4143.82,
                            "percent": 0.70,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/opt/iot_batch_uploader/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/docker/mapped/inputfolder",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot/batch-uploader-state",
                            "destination": "/opt/iot_batch_uploader/state",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-fsbms",
                    "id": "097fedb1323ccc080efef9dabf91d85593d849d255a2c03832c6903cf6261fd1",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-fsbms:1.0.20",
                    "status": "running",
                    "created": "2026-09-07T10:25:26.700335066Z",
                    "started": "2026-09-07T10:25:27.974707977Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 13.12,
                        "memory": {
                            "usage_bytes": 311432806,
                            "limit_bytes": 4345103770,
                            "usage_mb": 297.01,
                            "limit_mb": 4143.82,
                            "percent": 8.25,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/assets/fsbms",
                            "destination": "/app/assets/xml",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/mnt/iot/parsed",
                            "destination": "/app/output",
                            "type": "bind",
                            "mode": "z"
                        },
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/app/config.json",
                            "type": "bind",
                            "mode": ""
                        },
                        {
                            "source": "/var/lib/iot",
                            "destination": "/app/assets/configs",
                            "type": "bind",
                            "mode": ""
                        }
                    ]
                },
                {
                    "name": "iot-packs-simulator",
                    "id": "2b1128cae770209fbbc6582e56de591f1db341fbfab3128c0100932989189ab7",
                    "image": "302652831229.dkr.ecr.us-east-1.amazonaws.com/fsbms/edge/iot-packs-simulator:1.0.7",
                    "status": "running",
                    "created": "2026-09-07T10:24:31.297962702Z",
                    "started": "2026-09-07T10:24:31.474311558Z",
                    "state": {
                        "running": true,
                        "paused": false,
                        "restarting": false,
                        "exit_code": 0,
                        "error": "",
                        "restart_count": 0
                    },
                    "resources": {
                        "cpu_percent": 1.6,
                        "memory": {
                            "usage_bytes": 581663744,
                            "limit_bytes": 4345103770,
                            "usage_mb": 554.71,
                            "limit_mb": 4143.82,
                            "percent": 15.40,
                            "cache": 0,
                            "rss": 0
                        },
                        "block_io": {
                            "read_bytes": 0,
                            "write_bytes": 0,
                            "read_mb": 0,
                            "write_mb": 0
                        }
                    },
                    "networks": {
                        "host": {
                            "ip_address": "",
                            "gateway": "",
                            "mac_address": ""
                        }
                    },
                    "mounts": [
                        {
                            "source": "/var/lib/iot/device-config.json",
                            "destination": "/container/device-config.json",
                            "type": "bind",
                            "mode": "ro"
                        }
                    ]
                }
            ],
            "summary": {
                "total_containers": 7,
                "running": 7,
                "stopped": 0,
                "paused": 0,
                "restarting": 0,
                "unhealthy": 1,
                "total_cpu_percent": 34.36,
                "total_memory_mb": 1236.15,
                "containers_with_errors": 0
            }
        },
        "logs": {
            "timestamp": "2026-09-07T17:16:47.612982Z",
            "enabled": true,
            "files_configured": 8,
            "files_accessible": 8,
            "errors": [],
            "warnings": [
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:17:02.542Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:06:49,442 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T18:05:05.767Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:23.249Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:10,147 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T20:07:01.777Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:18:58.868Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:45,767 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T14:34:07.967Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:02.606Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:49,504 - canopen_listener - INFO - CANopen listener is running and processing telemetry data. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T05:34:46.256Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:03.133Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:08:50,032 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3600, tcell_samples=3606, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T11:48:10.565Z",
                    "level": "warning"
                },
                {
                    "source": "blackbox",
                    "message": "2026-09-07T11:19:23.260Z [WARN] (Copier) bms.iot.iot-blackbox: stderr. 2026-03-10 05:09:10,158 - canopen_listener - INFO - Flushed interval: captured signals=['SOC', 'SOH', 'BatteryVoltage', 'BatteryCurrent'], vcell_samples=3606, tcell_samples=3603, active_events={'BMSState': 'charge', 'BMSMode': 'CONNECTED'}. {scriptName=services.bms.iot.iot-blackbox.lifecycle.Run.Script, serviceName=bms.iot.iot-blackbox, currentState=RUNNING}",
                    "timestamp": "2026-09-07T15:52:04.797Z",
                    "level": "warning"
                }
            ],
            "summary": {
                "total_errors": 0,
                "total_warnings": 23,
                "errors_by_source": {},
                "warnings_by_source": {
                    "device_controller": 52,
                    "batch_uploader": 67,
                    "candump_uploader": 13,
                    "fsbms": 34,
                    "blackbox": 34
                },
                "files_with_errors": 0,
                "total_lines_scanned": 200
            }
        },
        "stream_manager": {
            "enabled": true,
            "connected": true,
            "timestamp": "2026-09-07T21:27:38.066613Z",
            "streams": [
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 12001
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 45987
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-staging-us-east-1-iot-status",
                    "message_count": 0
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-prod-us-east-1-iot-status",
                    "message_count": 12001
                },
                {
                    "name": "candump-uploader-bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 48
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-staging-us-east-1-iot-status",
                    "message_count": 0
                },
                {
                    "name": "batch-uploader-bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 1375
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-prod-us-east-1-iot-data",
                    "message_count": 89563
                },
                {
                    "name": "bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 0
                },
                {
                    "name": "bms-src-iot-us-east-1-staging-iot-data",
                    "message_count": 0
                },
                {
                    "name": "candump-uploader-lem-fsbms-raw-staging-us-east-1-iot-data",
                    "message_count": 0
                },
                {
                    "name": "batch-uploader-bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 1375
                },
                {
                    "name": "candump-uploader-bms-src-iot-us-east-1-staging-iot-status",
                    "message_count": 48
                },
                {
                    "name": "batch-uploader-lem-fsbms-raw-staging-us-east-1-iot-data",
                    "message_count": 0
                }
            ],
            "total_streams": 16,
            "total_messages": 162401
        },
        "can_interface": {
            "interface": "canE",
            "configured": true,
            "timestamp": "2026-09-07T14:00:46.918398",
            "operational_state": "up",
            "interface_details": "5: canE: <NOARP,UP,LOWER_UP,ECHO> mtu 16 qdisc pfifo_fast state UP mode DEFAULT group default qlen 10\n    link/can  promiscuity 0 minmtu 0 maxmtu 0 \n    can <LOOPBACK> state ERROR-ACTIVE (berr-counter tx 0 rx 0) restart-ms 0 \n\t  bitrate 250000 sample-point 0.875\n\t  tq 50 prop-seg 37 phase-seg1 32 phase-seg2 10 sjw 1 brp 2\n\t  flexcan: tseg1 2..96 tseg2 2..32 sjw 1..16 brp 1..1024 brp_inc 1\n\t  flexcan: dtseg1 2..39 dtseg2 2..8 dsjw 1..4 dbrp 1..1024 dbrp_inc 1\n\t  clock 40000000 numtxqueues 1 numrxqueues 1 gso_max_size 65536 gso_max_segs 65535 parentbus platform parentdev 308d0000.can",
            "state": "UP",
            "statistics": {
                "rx_packets": "36090731024",
                "rx_bytes": "4511341378",
                "rx_errors": "0",
                "rx_dropped": "0",
                "tx_packets": "18045365512",
                "tx_bytes": "2255670689",
                "tx_errors": "0",
                "tx_dropped": "0"
            },
            "manager_stats": {
                "setup_count": 1,
                "recovery_count": 1,
                "failed_recovery_count": 0,
                "recovery_attempts": 0,
                "last_error": null
            },
            "uptime_seconds": 10808315
        },
        "alerts": [
            {
                "level": "critical",
                "message": "Stream Manager message backlog critical: 111213 messages",
                "timestamp": "2026-09-07T08:15:14.146316Z"
            }
        ],
        "topic": "iot/devices/iot0001c037a4fc/health"
    },
}

export type EdgeSample = typeof edgeSample;
export type EdgeKey = keyof EdgeSample;

export function getEdgeSample(key: string): EdgeSample[EdgeKey] | undefined {
  if (key in edgeSample) {
    return edgeSample[key as EdgeKey];
  }
  return undefined;
}